import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FeaturedCard.module.scss";
import {FontIcon} from "../../common/FontIcon";

export interface IFeaturedCardProps {
  headline: string;
  title: string;
  artistName?: string;
  difficultyLevel?: "rookie" | "intermediate" | "advanced";
  difficultyOrCount: string;
  hasVideo?: boolean;
  imgUrl: string;
  onClick: () => void;
}

export const FeaturedCard: VoidFunctionComponent<IFeaturedCardProps> = ({
  headline,
  title,
  artistName,
  difficultyLevel,
  difficultyOrCount,
  hasVideo,
  imgUrl,
  onClick,
}) => {
  const useClasses: string[] = [s.featuredCard];
  if (difficultyLevel) {
    useClasses.push(s[`${difficultyLevel}`]);
  }

  return (
    <button type={"button"} className={useClasses.join(` `)} onClick={onClick}>
      <p className={s.cardHeadline}>{headline}</p>
      <h4 className={s.cardTitle}>{title}</h4>
      <p className={s.cardArtist}>{artistName}</p>
      <div className={s.cardSecondaryInfo}>
        {hasVideo ? <FontIcon icon={"icon-video-tutorial-solid"}/> : null}
        <p className={s.cardDifficultyOrCount}>{difficultyOrCount}</p>
      </div>
      <div className={s.cardImgWrapper}>
        <img className={s.cardImg} src={imgUrl} alt={""} width={"600"} height={"600"} />
      </div>
    </button>
  );
}
